package one.healthium.channels.di

import one.healthium.channels.MealPlanChannel
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

val channelsModule = module {
    singleOf(::MealPlanChannel)
}